<template>
  <div v-show="show">
    <div class="margin-top-20 item-cursor"
         v-for="(jsonElement, index) in filteredJsonElements"
         :key="index"
         @click="onDataTableDataSelected(jsonElement, index)">
      <data-table-data-item
          :json-element="jsonElement"
          :header-field-data-list="headerFieldDataList"
          :data-table-template="dataTableTemplate"
      ></data-table-data-item>
    </div>
  </div>
</template>

<script>


import EzUtils from "@/utils/EzUtils";
import DataTableDataItem from "@/components/layout/DataTableDataItem";

export default {
  name: "DataTableDataLayout",
  components: {DataTableDataItem},

  data: () => ({
    filteredJsonElements: [],

    dataTableTemplate: {},
    jsonElements: [],
    headerFieldDataList: [],
    filterFieldDataList: []
  }),

  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  methods: {
    onDataTableDataSelected(jsonElement, index) {
      this.$emit("onDataTableDataSelected", index, jsonElement);
    },

    showExistingRecords(
        dataTableTemplate,
        jsonElements,
        headerFieldDataList,
        filterFieldDataList
    ) {
      this.dataTableTemplate = dataTableTemplate;
      this.jsonElements = jsonElements;
      this.headerFieldDataList = headerFieldDataList;
      this.filterFieldDataList = filterFieldDataList;

      const filteredJsonElements = [];
      jsonElements && jsonElements.forEach(jsonElement => {
        if (this.needToShowData(jsonElement)) {
          filteredJsonElements.push(jsonElement);
        }
      });

      this.filteredJsonElements = filteredJsonElements;

      this.$emit("onFilteredJsonElements", this.filteredJsonElements);
    },

    needToShowData(jsonElement) {
      if (!jsonElement) {
        return false;
      }

      if (EzUtils.isEmpty(this.filterFieldDataList)) {
        return true;
      }

      let showData = true;
      if (this.dataTableTemplate) {
        const columnHeaders = this.dataTableTemplate["columnHeaderData"];
        columnHeaders && columnHeaders.forEach(columnHeader => {
          const columnNameWithoutCodeLookUp = EzUtils.getColumnNameWithoutCodeLookup(columnHeader);
          const columnValue = EzUtils.getFieldValueForColumnHeader(columnHeader, jsonElement);

          this.filterFieldDataList.forEach(stageFieldData => {
            if (columnNameWithoutCodeLookUp === stageFieldData["field"]
                && EzUtils.isNotEmpty(stageFieldData["masterData"])
                && (!columnValue || !stageFieldData["masterData"].includes(columnValue))
            ) {
              showData = false;
            }
          })
        })
      }

      return showData;
    }
  }
}
</script>

<style scoped>

.edit-btn {
  height: 30px;
  width: 30px;
  border-radius: 30px;
  background: #1976d2;
  position: absolute;
  right: 10px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  top: 5px;
  -webkit-box-shadow: 3px 1px 7px 0 #5a5959;
  box-shadow: 3px 1px 7px 0 #5a5959;
  cursor: pointer;
}
</style>

<style
    scoped
    src="../../assets/style/base.css"></style>